const STORAGE_KEY = 'blackroom:view-as';
export const VIEW_AS_STORAGE_EVENT_KEY = STORAGE_KEY;
export const VIEW_AS_USER_ID_HEADER = 'X-View-As-User-Id';
export const VIEW_AS_WORKSPACE_ID_HEADER = 'X-View-As-Workspace-Id';

export type ViewAsUser = {
  id: string;
  // The API scopes view-as to this single workspace.
  workspaceId: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
};

let currentViewAsUser: ViewAsUser | null = readFromStorage();

function readFromStorage(): ViewAsUser | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as ViewAsUser;
    if (!parsed?.id || !parsed?.email || !parsed?.workspaceId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function getViewAsUser(): ViewAsUser | null {
  return currentViewAsUser;
}

export function getViewAsUserId(): string | null {
  return currentViewAsUser?.id ?? null;
}

export function getViewAsRequestHeaders(): Record<string, string> {
  return currentViewAsUser
    ? {
        [VIEW_AS_USER_ID_HEADER]: currentViewAsUser.id,
        [VIEW_AS_WORKSPACE_ID_HEADER]: currentViewAsUser.workspaceId,
      }
    : {};
}

// graphql-ws connection params are plain JSON keys: the API reads them lowercase.
export function getViewAsConnectionParams(): Record<string, string> {
  return Object.fromEntries(
    Object.entries(getViewAsRequestHeaders()).map(([name, value]) => [
      name.toLowerCase(),
      value,
    ]),
  );
}

export function setViewAsUser(user: ViewAsUser | null): void {
  currentViewAsUser = user;
  try {
    if (user) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore: storage may be disabled (private mode, quota, etc.)
  }
}

// Keeps the singleton in sync when another tab changes the value.
export function refreshFromStorage(): ViewAsUser | null {
  currentViewAsUser = readFromStorage();
  return currentViewAsUser;
}
